import styled, { css } from "styled-components";

/**
 * Shared screen panel styles for dark display sections.
 * Provides a glass-like appearance with bevel border and diagonal reflection.
 */
export const screenPanelStyles = css`
  position: relative;
  background: linear-gradient(180deg, #39393b 0%, #040608 100%);
  border-radius: 8px;

  /* Bevel effect using box-shadow */
  box-shadow: inset 2px 2px 0 rgba(255, 255, 255, 0.15),
    inset -2px -2px 0 rgba(0, 0, 0, 0.3);
`;

/**
 * A styled div with screen panel appearance.
 * Use this component directly or apply screenPanelStyles to existing components.
 */
const ScreenPanel = styled.div`
  ${screenPanelStyles}
`;

export default ScreenPanel;
